export const SET_CHECKOUT = 'setCheckout'
export const SET_CHECKOUTS = 'setCheckouts'
export const SET_CHECKOUT_ACTIVE = 'setCheckoutActive'
export const CHECKOUT_RESET = 'checkoutReset'
export const CHECKOUT_RESET_STATE = 'checkoutResetState'
export const SET_CHECKOUT_PAGINATION = 'setCheckoutPagination'
export const SET_CHECKOUTS_STATUS_LIST = 'setCheckoutStatusList'
export const SET_CHECKOUT_SCHEDULES = 'setCheckoutSchedules'
export const SET_CHECKOUT_SCHEDULE = 'setCheckoutSchedule'
export const SET_CHECKOUT_SCHEDULES_PAGINATION = 'setCheckoutSchedulesPagination'